<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title"> Purchas Orders</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal hover-white" @click="openCreateModal('createModal')">
          <i class="fa fa-plus fs-11"></i> Add New Order
        </button>

        <!-- <button type="button" class="btn btn-md btn-outline-primary fs-11 fw-normal text-primary hover-white"> <i
            class="fa fa-list fs-11 text-primary hover-white "></i> Users List</button> -->
      </div>
    </div>
    <!-- Sirf Filters Bar -->
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger hover-white">
        <span class="material-symbols-outlined fs-6">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
    <div class="card p-1 bg-white">


      <!-- Modal with CreateOrder inside slot -->
      <FormModal ref="createModal" title="Create New Order" id="create_order_form_modal">
        <CreateOrder :roles="roles" @click="f" ref="createOrderForm" @created="onOrderCreated"
          @close="closeCreateModal('createModal')" />
      </FormModal>

      <!-- Receive Order Modal -->
      <FormModal ref="receiveModal" title="Receive Purchase Order" id="receive_order_modal">
        <ReceiveOrderModal ref="receiveModalParent" @received="fetchOrders"
          @close="() => { if ($refs.receiveModal) $refs.receiveModal.closeModal() }" />
      </FormModal>

      <!-- Verify Order Modal -->
      <FormModal ref="verifyModal" title="Verify Purchase Order" id="verify_order_modal">
        <VerifyOrder ref="verifyModalParent" @verified="fetchOrders"
          @close="() => { if ($refs.verifyModal) $refs.verifyModal.closeModal() }" />
      </FormModal>

      <!-- Loading State -->
      <LoadingBar v-if="loading" message="Loading Orders..." />

     <div v-else class="table-wrapper">
  <ListTable>

    <colgroup>
      <!-- <col style="width: 6%">  -->
      <col style="width: 34%">  <!-- Order -->
      <col style="width: 20%">  <!-- Vendor -->
      <col style="width: 12%">  <!-- Status -->
      <col style="width: 14%">  <!-- Created On -->
      <col style="width: 14%">  <!-- Updated On -->
      <col style="width: 6%">   <!-- Action -->
    </colgroup>

    <thead>
      <tr>
        <!-- <th>SR#</th> -->

        <th @click="sortBy('id')" class="sortable">
          Order ID <i :class="getSortIcon('id')"></i>
        </th>

        <th @click="sortBy('vendor')" class="sortable">
          Vendor <i :class="getSortIcon('vendor')"></i>
        </th>

        <th @click="sortBy('status')" class="sortable">
          Status <i :class="getSortIcon('status')"></i>
        </th>

        <th @click="sortBy('created_at')" class="sortable">
          Created On <i :class="getSortIcon('created_at')"></i>
        </th>

        <th @click="sortBy('updated_at')" class="sortable">
          Updated On <i :class="getSortIcon('updated_at')"></i>
        </th>

        <th class="text-center">Action</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="order in sortedData" :key="order.id">

        <!-- SR# -->
        <!-- <td>
            {{ index + 1 }}
        </td> -->

        <!-- Order -->
        <td class="align-middle">
          <div class="d-flex align-items-center gap-2">
            <div
              class="d-flex align-items-center justify-content-center bg-primary-subtle border border-primary-subtle rounded-3"
              style="width: 40px; height: 40px; min-width: 40px;">

              <span class="material-symbols-outlined text-primary fs-10">
                shopping_cart
              </span>
            </div>

            <div>
              <a href="#" class="text-decoration-none" @click.prevent="viewProfile(order.external_id)">
                <div class="text-dark">{{ order.name ?? 'N/A' }}</div>
              </a>
              <div class="text-muted small">{{ order.external_id }}</div>
            </div>
          </div>
        </td>

        <td>{{ order.vendor?.first_name ?? 'N/A' }}</td>

        <td>
          <PoStatus :status="order.status" />
        </td>

        <td>{{ order.created_at }}</td>

        <td>{{ order.updated_at }}</td>

        <td class="text-center">
          <TableActionDropdown>
            <li>
              <a class="dropdown-item" @click.prevent="viewProfile(order.external_id)">
                <i class="fa fa-eye text-info"></i>
                <span>Profile</span>
              </a>
            </li>

            <li>
              <a class="dropdown-item" href="#">
                <i class="fa fa-pencil text-primary"></i>
                <span>Edit</span>
              </a>
            </li>

            <li v-if="canReceive(order)">
              <a class="dropdown-item" @click.prevent="openReceiveModal(order)">
                <i class="fa fa-arrow-down text-success"></i>
                <span>Receive</span>
              </a>
            </li>

            <li v-if="canVerify(order)">
              <a class="dropdown-item" @click.prevent="openVerifyModal(order)">
                <i class="fa fa-check-circle text-warning"></i>
                <span>Verify</span>
              </a>
            </li>

          
              <hr class="dropdown-divider" />
   

            <li>
              <a class="dropdown-item item-danger" @click.prevent="deleteOrder(order)">
                <i class="fa fa-trash"></i>
                <span>Delete</span>
              </a>
            </li>
          </TableActionDropdown>
        </td>

      </tr>

      <tr v-if="sortedData.length === 0">
        <td colspan="7" class="text-center">No orders found</td>
      </tr>
    </tbody>

  </ListTable>
</div>

      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />

    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateOrder from '@/views/PurchaseOrders/CreateOrder.vue'
import ListTable from '@/components/utils/ListTable.vue'
import PoStatus from '@/components/PoStatus.vue'
import ReceiveOrderModal from '@/views/PurchaseOrders/ReceiveOrderModal.vue'
import VerifyOrder from '@/views/PurchaseOrders/VerifyOrder.vue'
import TableActionDropdown from '@/components/TableActionDropdown.vue'
export default {
  name: 'PurchaseOrderList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateOrder,
    ListTable,
    PoStatus,
    ReceiveOrderModal,
    VerifyOrder,
    TableActionDropdown
  },
  data() {
    return {
      orders: [],
      vendors: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      filterManager: null,
      sortColumn: null,
      sortOrder: 'asc',
      filteredData: [],
      currentFilters: {},
    }
  },
  computed: {

    // Sorted data
    sortedData() {
      let result = [...this.filteredData];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (this.sortColumn === 'id') {
            valA = parseInt(String(valA).replace('#', '')) || 0;
            valB = parseInt(String(valB).replace('#', '')) || 0;
          }

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
  },
  mounted() { //doc read
    // alert(localStorage.getItem('user_token'));
    this.fetchOrders()
    this.fetchVendors()
  },
  methods: {
    openCreateModal(ref) {
      this.$refs[ref].showModal()

    },

    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },

    openReceiveModal(order) {
      if (this.$refs.receiveModal) this.$refs.receiveModal.showModal()
      this.$nextTick(() => {
        const modalRef = this.$refs.receiveModalParent
        if (modalRef && modalRef.setOrder) {
          modalRef.setOrder(order)
        }
      })
    },
    openVerifyModal(order) {
      if (this.$refs.verifyModal) this.$refs.verifyModal.showModal()
      this.$nextTick(() => {
        const modalRef = this.$refs.verifyModalParent
        if (modalRef && modalRef.setOrder) {
          modalRef.setOrder(order)
        }
      })
    },
    async onOrderCreated() {
      this.pagination.current_page = 1
      await this.fetchOrders()
    },

    async fetchOrders() {
      this.loading = true

      // include assigned flag only; backend should resolve current user with request()->user()
      const payload = {
        page: this.pagination.current_page,
        ...this.currentFilters
      }

      const result = await form_api_submit({
        url: 'purchase-order/list',
        method: 'GET',
        data: payload,
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        console.log(result);
        this.orders = result.data.list
        this.filteredData = [...result.data.list]
        this.pagination = result.data.pagination
      }
      this.loading = false
    },
    async fetchVendors() {
      this.loading = true
      const result = await form_api_submit({
        url: 'vendor/get-vendors',
        method: 'GET',
        data: {

        },
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        this.vendors = result.data.list || result.data || []
        console.log(this.vendors);
        this.$nextTick(() => {
          setTimeout(() => {
            this.initFilters();
          }, 100);
        });
      }

      this.loading = false
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      this.fetchOrders()
    },
    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      const VendorOptions = (this.vendors || []).map(vendor => ({
        value: String(vendor.id),
        label: vendor.first_name
      }));

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "id",
            label: "ID",
            type: "input",
            placeholder: "Filter by ID"
          },
          {
            key: "name",
            label: "Name",
            type: "input",
            placeholder: "Filter by Name"
          },
          {
            key: "vendor",
            label: "Vendor",
            type: "checkbox",
            options: VendorOptions
          },
          {
            key: "status",
            label: "Status",
            type: "checkbox",
            options: [
              { value: 'pending', label: 'Pending' },
              { value: 'approved', label: 'Approved' },
              { value: 'rejected', label: 'Rejected' },
              { value: 'completed', label: 'Completed' },
            ]

          }

          , {
            key: "assigned",
            label: "Assigned",
            type: "radio",
            options: [
              // { value: 'all', label: 'All purchase order' },
              { value: 'assigned', label: 'Assigned to me' }
            ]
          }

        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchOrders();
    },
    currentUserId() {
      return localStorage.getItem('user_id') ? String(localStorage.getItem('user_id')) : null
    },
    canReceive(order) {
  const currentId = this.currentUserId()
  console.log('Current User ID:', currentId, 'Type:', typeof currentId)
  console.log('Order Roles:', order?.purchase_order_user_roles)
  
  if (!currentId || !order?.purchase_order_user_roles) return false

  const receivedIds = order.purchase_order_user_roles
    .filter(roleEntry => String(roleEntry.role) === 'received_by')
    .map(roleEntry => String(roleEntry.user_id))
  
  console.log('Received IDs:', receivedIds)
  console.log('Includes?', receivedIds.includes(currentId))

  return receivedIds.includes(currentId)
},
    canVerify(order) {
      const currentId = this.currentUserId()
      if (!currentId || !order?.purchase_order_user_roles) return false

      const verifyIds = order.purchase_order_user_roles
        .filter(roleEntry => String(roleEntry.role) === 'verification_by')
        .map(roleEntry => String(roleEntry.user_id))

      return verifyIds.includes(currentId)
    },
    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchOrders();
    },
    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.currentFilters = {};
      this.sortColumn = null;
      this.sortOrder = 'asc';
      this.pagination.current_page = 1;
      this.fetchOrders();
    },
    // Sorting method
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
      this.resetPagination(); // Reset to first page when sorting changes
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
    viewVendorProfile(external_id) {
      this.$router.push({ name: 'VendorProfile', params: { external_id } })
    },
    viewProfile(external_id) {
      this.$router.push({ name: 'OrderProfile', params: { external_id } })
    }

  }
}
</script>

<style scoped>
/* .card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
} */

.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}
</style>